import styled from "styled-components";

const ButtonSection = styled.div`
margin-left: auto;

`

export default ButtonSection;